import { z } from 'zod'

export const QuestionSchema = z.object({
  id: z.number(),
  /** For some reason the name is an extra */
  name: z.string(),
  code: z.string(),
  answers: z.array(z.string()),
})

export type Question = z.infer<typeof QuestionSchema>

export const InterestSchema = z.object({
  name: z.string(),
  state: z.boolean(),
  no_answer: z.boolean(),
  date: z.string(),
  code: z.string(),
})

export type Interest = z.infer<typeof InterestSchema>

export const SurveyAnswerSchema = InterestSchema.omit({
  date: true,
})

export type SurveyAnswer = z.infer<typeof SurveyAnswerSchema>
